import { Trans } from 'react-i18next'

import { useActiveLayerContext } from '@/context/__project__/ActiveLayerContext'
import { useBuilderActionContextV2 } from '@/context/__project__/BuilderActionContextV2'
import { useCompBackgroundColor, useCompContext } from '@/context/__project__/CompContext'
import { useDbClientContext } from '@/context/__project__/DbClientContext'
import { ComponentSettingKey } from '@/shared/builder'
import { getSafely } from '@/shared/safely'

import { CompPricingWrapperCore } from '../core/pricing/wrapper'

function CompPricingWrapper() {
  // infos
  const compContext = useCompContext()
  const { currentParentBg } = useCompBackgroundColor()
  const { activeLayer } = useActiveLayerContext()
  const infosProps = { ...compContext, activeLayer, currentParentBg }

  // action
  const action = useBuilderActionContextV2()

  // tableData
  const { dbClient, language, userSpecific, tablesMap } = useDbClientContext()
  const tableId = compContext.settings?.[ComponentSettingKey.PricingDataSource]
  const dbTable = tableId ? tablesMap.get(tableId) : undefined

  const featuresTableId = getSafely(compContext.settings, [ComponentSettingKey.PricingDataFeaturesSource, 'table'], '')
  const featuresDbTable = featuresTableId ? tablesMap.get(featuresTableId) : undefined

  if (!dbTable || !dbClient || !featuresDbTable) {
    return (
      <div className='flex justify-center items-center py-8'>
        <Trans>COMP_TABLE_NOT_FOUND</Trans>
      </div>
    )
  }

  return (
    <CompPricingWrapperCore
      infos={infosProps}
      action={action}
      tableData={{ tableId, dbTable, dbClient, language, userSpecific }}
      featuresTableData={{ tableId: featuresTableId, dbTable: featuresDbTable, dbClient, language, userSpecific }}
    />
  )
}

export default CompPricingWrapper
